export const COOPERANT_ORDERS_PERMISSIONS = {
    READ: 'cooperant_orders_read'
} as const
